import classes from "./RestoranImage.module.css";

const RestoranImage = (props) => {
  return (
    <div className={classes["offer-container"]}>
      <div className={classes["offer-photo--container"]}>
        <img className={classes["offer-photo"]} src={props.offer} alt="offer" />
        <div className={classes["offer-infos"]}>
          <div className={classes.flex}>
            {/* <div className={classes["offer-info-discount"]}>
              İndirimli Lezzetler
            </div> */}
            <div className={classes["offer-info-fav"]}>
              <svg
                data-testid="icon"
                color="#FFF"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
              >
                <path d="M29.358 4.507c-.839-.839-1.845-1.51-2.95-1.971s-2.279-.685-3.481-.685a9.31 9.31 0 0 0-3.481.685 9.178 9.178 0 0 0-2.95 1.971l-.489.503-.489-.489a9.074 9.074 0 0 0-6.431-2.656c-2.405 0-4.725.951-6.431 2.656S0 8.533 0 10.952a9.08 9.08 0 0 0 2.656 6.431l12.358 12.358a1.392 1.392 0 0 0 1.971 0l12.358-12.358c.839-.839 1.51-1.845 1.971-2.95s.685-2.279.685-3.481a9.256 9.256 0 0 0-.685-3.481 8.992 8.992 0 0 0-1.957-2.964zm-.615 8.835a6.326 6.326 0 0 1-1.37 2.041l-11.366 11.38L4.641 15.397a6.31 6.31 0 0 1-1.845-4.446c0-1.664.657-3.271 1.845-4.446C5.815 5.331 7.423 4.66 9.087 4.66s3.271.657 4.446 1.845l1.482 1.482a1.392 1.392 0 0 0 1.971 0l1.482-1.482c.587-.587 1.272-1.049 2.041-1.37s1.58-.475 2.405-.475c.825 0 1.649.168 2.404.475s1.454.783 2.041 1.37 1.049 1.272 1.37 2.041c.322.769.475 1.58.475 2.405s-.14 1.636-.461 2.39z" />
              </svg>
            </div>
          </div>

          <div className={classes.flex}>
            <div className={classes["offer-info-confirmed-photo"]}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="path-1-outside-1"
                  maskUnits="userSpaceOnUse"
                  x="3"
                  y="5"
                  width="32"
                  height="32"
                  fill="black"
                >
                  <rect fill="white" x="3" y="5" width="23" height="21" />
                  <path d="M21.1538 9.37363H19.4231L18.8461 8.1868C18.5063 7.49607 18.3298 7 17.6923 7H10.7692C10.1317 7 9.92114 7.56611 9.61535 8.1868L9.03842 9.37363H7.30769C6.03326 9.37363 5 10.4364 5 11.7473V21.2418C5 22.5526 6.03326 23.6154 7.30769 23.6154H21.1539C22.4283 23.6154 23.4615 22.5526 23.4615 21.2418V11.7473C23.4615 10.4364 22.4282 9.37363 21.1538 9.37363Z" />
                </mask>
                <path
                  d="M21.1538 9.37363H19.4231L18.8461 8.1868C18.5063 7.49607 18.3298 7 17.6923 7H10.7692C10.1317 7 9.92114 7.56611 9.61535 8.1868L9.03842 9.37363H7.30769C6.03326 9.37363 5 10.4364 5 11.7473V21.2418C5 22.5526 6.03326 23.6154 7.30769 23.6154H21.1539C22.4283 23.6154 23.4615 22.5526 23.4615 21.2418V11.7473C23.4615 10.4364 22.4282 9.37363 21.1538 9.37363Z"
                  fill="#5D3EBC"
                />
                <path
                  d="M19.4231 9.37363L17.8287 10.1486L18.3137 11.1464H19.4231V9.37363ZM18.8461 8.1868L20.4405 7.41177L20.4368 7.4042L18.8461 8.1868ZM9.61535 8.1868L8.02512 7.40333L8.02101 7.41178L9.61535 8.1868ZM9.03842 9.37363V11.1464H10.1478L10.6328 10.1486L9.03842 9.37363ZM23.4615 11.7473H25.2343V11.7472L23.4615 11.7473ZM21.1538 7.6009H19.4231V11.1464H21.1538V7.6009ZM21.0174 8.5986L20.4405 7.41177L17.2518 8.96182L17.8287 10.1486L21.0174 8.5986ZM20.4368 7.4042C20.3377 7.20282 20.0907 6.63883 19.7715 6.23504C19.5741 5.98531 19.2952 5.71261 18.904 5.51159C18.5069 5.30752 18.0914 5.22727 17.6923 5.22727V8.77273C17.612 8.77273 17.4576 8.75449 17.2835 8.66502C17.1153 8.5786 17.0213 8.47309 16.9901 8.43371C16.9686 8.40641 16.9813 8.41566 17.0376 8.5244C17.0635 8.5745 17.0924 8.63316 17.1298 8.71036C17.1642 8.78139 17.2099 8.87666 17.2555 8.9694L20.4368 7.4042ZM17.6923 5.22727H10.7692V8.77273H17.6923V5.22727ZM10.7692 5.22727C9.78357 5.22727 9.09404 5.7257 8.66899 6.27177C8.35301 6.67771 8.11138 7.22829 8.02514 7.40335L11.2056 8.97025C11.2472 8.88564 11.2904 8.79559 11.322 8.73034C11.3568 8.65851 11.3841 8.60304 11.4091 8.55488C11.4626 8.45164 11.4794 8.43332 11.4668 8.44952C11.4486 8.47293 11.3697 8.56764 11.2171 8.65156C11.0518 8.74245 10.8875 8.77273 10.7692 8.77273V5.22727ZM8.02101 7.41178L7.44408 8.5986L10.6328 10.1486L11.2097 8.96182L8.02101 7.41178ZM9.03842 7.6009H7.30769V11.1464H9.03842V7.6009ZM7.30769 7.6009C5.00746 7.6009 3.22727 9.50477 3.22727 11.7473H6.77273C6.77273 11.368 7.05905 11.1464 7.30769 11.1464V7.6009ZM3.22727 11.7473V21.2418H6.77273V11.7473H3.22727ZM3.22727 21.2418C3.22727 23.4842 5.00745 25.3881 7.30769 25.3881V21.8427C7.05907 21.8427 6.77273 21.6209 6.77273 21.2418H3.22727ZM7.30769 25.3881H21.1539V21.8427H7.30769V25.3881ZM21.1539 25.3881C23.454 25.3881 25.2343 23.4843 25.2343 21.2418H21.6888C21.6888 21.6209 21.4025 21.8427 21.1539 21.8427V25.3881ZM25.2343 21.2418V11.7473H21.6888V21.2418H25.2343ZM25.2343 11.7472C25.2342 9.50483 23.4541 7.6009 21.1538 7.6009V11.1464C21.4024 11.1464 21.6888 11.368 21.6888 11.7473L25.2343 11.7472Z"
                  fill="white"
                  mask="url(#path-1-outside-1)"
                />
                <path
                  d="M14.5 11C12.0145 11 10 13.0145 10 15.5C10 17.9855 12.0145 20 14.5 20C16.9855 20 19 17.9855 19 15.5C19 13.0145 16.9855 11 14.5 11Z"
                  fill="white"
                />
                <path
                  d="M14.5 12C12.5668 12 11 13.5668 11 15.5C11 17.4332 12.5668 19 14.5 19C16.4332 19 18 17.4332 18 15.5C18 13.5668 16.4332 12 14.5 12Z"
                  fill="#5D3EBC"
                />
                <path
                  d="M23.5 16C20.4622 16 18 18.4622 18 21.5C18 24.5379 20.4622 27 23.5 27C26.5378 27 29 24.5379 29 21.5C29 18.4621 26.5378 16 23.5 16Z"
                  fill="white"
                />
                <path
                  d="M23.5 17C21.0145 17 19 19.0145 19 21.5C19 23.9855 21.0145 26 23.5 26C25.9855 26 28 23.9855 28 21.5C28 19.0145 25.9855 17 23.5 17Z"
                  fill="#54BA4F"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.5708 19.2311C26.8137 19.4542 26.8348 19.8376 26.6178 20.0874L23.4054 23.9391C23.2935 24.0679 23.1335 24.1416 22.9656 24.1416C22.7976 24.1416 22.6377 24.0679 22.5258 23.9391L20.8422 22C20.6253 21.7501 20.6463 21.3668 20.8892 21.1437C21.1321 20.9206 21.5048 20.9422 21.7217 21.192L22.9656 22.6247L25.7383 19.2795C25.9552 19.0296 26.3279 19.008 26.5708 19.2311Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestoranImage;
